/*!
 * Vimeo LazyLoad
 * v1.0.2
 * https://github.com/the-muda-organization/vimeo-lazyload
 * MIT License
 */
(function($) {

    //select all elements with class .vi-lazyload
    var $vimeo = $('.vi-lazyload[data-type="vimeo"]');

    //for each element execute:

    $vimeo.each(function(i, e) {

        var $this = $(this),
            id = $this.data('id'),
            vi_image = new Image(),
            custom_image = $this.data('thumbnail'),
            vi_playbtn = document.createElement('div'),
            $image = $this.find('.vi-lazyload-img');

        $.getJSON('https://vimeo.com/api/v2/video/' + id + '.json', function(data) {

            data = data[0];

            //image - thumbnail
            vi_image.classList.add('vi-lazyload-img');
            if( custom_image !== undefined ){
                vi_image.src = custom_image;
                e.appendChild(vi_image);
            }else{
                vi_image.src = data.thumbnail_large;
                vi_image.alt = data.title;

                //append thumbails after they are loaded
                vi_image.addEventListener('load', function() {}(i));

                e.appendChild(vi_image);
            }

            console.log(vi_image);

            //play btn
            vi_playbtn.classList.add('vi-lazyload-playbtn');
            e.appendChild(vi_playbtn);

            //create iframe onclick play-btn
            e.addEventListener('click', function() {
                var vi_container = this,
                    vi_iframe = document.createElement('iframe');

                vi_iframe.src = 'https://player.vimeo.com/video/' + vi_container.dataset.id + '?autoplay=1&autopause=0';
                vi_iframe.setAttribute('allow', 'autoplay;fullscreen');
                vi_iframe.setAttribute('allowfullscreen', '');
                vi_container.appendChild(vi_iframe);
            });
        });

    });

})(jQuery);
